<template>
  <div class="profile">
    <el-card class="profile-card">
      <template #header>
        <div class="card-header">
          <h2>个人信息</h2>
          <el-button type="primary" @click="handleEdit" v-if="!isEditing">编辑</el-button>
        </div>
      </template>
      
      <el-form 
        :model="form" 
        :rules="rules" 
        ref="formRef" 
        label-width="100px"
        :disabled="!isEditing"
        class="profile-form"
      >
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" disabled />
        </el-form-item>
        
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" />
        </el-form-item>
        
        <el-form-item label="新密码" prop="newPassword" v-if="isEditing">
          <el-input 
            v-model="form.newPassword" 
            type="password" 
            placeholder="不修改请留空"
            show-password
          />
        </el-form-item>
        
        <el-form-item label="确认密码" prop="confirmPassword" v-if="isEditing">
          <el-input 
            v-model="form.confirmPassword" 
            type="password" 
            placeholder="不修改请留空"
            show-password
          />
        </el-form-item>
        
        <el-form-item v-if="isEditing" class="form-actions">
          <el-button type="primary" @click="handleSubmit" :loading="submitting">
            保存
          </el-button>
          <el-button @click="cancelEdit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios'

const formRef = ref(null)
const isEditing = ref(false)
const submitting = ref(false)

const form = ref({
  username: '',
  email: '',
  newPassword: '',
  confirmPassword: ''
})

const validatePass = (rule, value, callback) => {
  if (value === '') {
    callback()
  } else {
    if (form.value.confirmPassword !== '') {
      formRef.value?.validateField('confirmPassword')
    }
    callback()
  }
}

const validatePass2 = (rule, value, callback) => {
  if (value === '') {
    callback()
  } else if (value !== form.value.newPassword) {
    callback(new Error('两次输入密码不一致'))
  } else {
    callback()
  }
}

const rules = {
  email: [
    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
    { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
  ],
  newPassword: [
    { validator: validatePass, trigger: 'blur' }
  ],
  confirmPassword: [
    { validator: validatePass2, trigger: 'blur' }
  ]
}

// 获取个人信息
const getProfile = async () => {
  try {
    const response = await axios.get('/api/admin/auth/profile')
    form.value = {
      username: response.data.username,
      email: response.data.email,
      newPassword: '',
      confirmPassword: ''
    }
  } catch (error) {
    ElMessage.error('获取个人信息失败')
  }
}

// 编辑
const handleEdit = () => {
  isEditing.value = true
}

// 取消编辑
const cancelEdit = () => {
  isEditing.value = false
  getProfile() // 重置表单
}

// 提交表单
const handleSubmit = async () => {
  if (!formRef.value) return
  
  try {
    await formRef.value.validate()
    submitting.value = true
    
    const updateData = {
      email: form.value.email
    }
    
    if (form.value.newPassword) {
      updateData.password = form.value.newPassword
    }
    
    const response = await axios.put('/api/admin/profile', updateData)
    
    ElMessage.success('更新成功')
    isEditing.value = false
    
    // 更新本地存储的管理员信息
    const admin = localStorage.getItem('admin')
    if (admin) {
      const adminInfo = JSON.parse(admin)
      adminInfo.email = form.value.email
      localStorage.setItem('admin', JSON.stringify(adminInfo))
    }
  } catch (error) {
    ElMessage.error(error.response?.data?.message || '更新失败')
  } finally {
    submitting.value = false
  }
}

onMounted(() => {
  getProfile()
})
</script>

<style scoped>
.profile {
  padding: 20px;
  min-height: calc(100vh - 60px);
  background-color: #f5f7fa;
}

.profile-card {
  max-width: 800px;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}

.card-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.profile-form {
  padding: 20px 0;
}

.form-actions {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .profile {
    padding: 16px;
  }
  
  .profile-card {
    margin: 0;
  }
  
  .form-actions {
    flex-direction: column;
    gap: 8px;
  }
  
  .form-actions .el-button {
    width: 100%;
  }
}
</style> 